import React from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { FormattedMessage } from 'react-intl';
import { Box } from '@material-ui/core';
import { SCROLLABLE_BODY } from '../MainLayout/MainLayout';

const useStyles = makeStyles((theme) => ({
  footer: {
    marginTop: 'auto',
  },
  footerContent: {
    padding: theme.spacing(1.5, 0),
    borderTop: `1px solid #e4e4e4`,
    marginTop: '1rem',
  },
  footerContentGrid: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  copyright: {
    display: 'inline-flex',
    color: '#e4e4e4',
    alignItems: 'center',
  },
  scrollToTopGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  scrollToTop: {
    display: 'inline-flex',
    alignItems: 'center',
    color: '#00c752',
    textTransform: 'uppercase',
    cursor: 'pointer',
  },
}));

const Footer = () => {
  const scrollToTop = () => {
    // ScrollableBody exists only inside MainLayout. Other layouts
    // (FormLayout, ContractLayout, PublicLayout) have no scroll wrapper
    // of their own, so the browser's default document scroll applies.
    // document.scrollingElement reliably returns whichever element is
    // actually scrolling in that case, instead of assuming it's #root
    // (which never scrolls itself, since nothing constrains its height).
    const element = document.getElementById(SCROLLABLE_BODY) || document.scrollingElement;
    element &&
      element.scroll({
        top: 0,
        behavior: 'smooth',
      });
  };

  const classes = useStyles({});
  return (
    <Container maxWidth="m" className={classes.footer}>
      <Box className={classes.footerContent}>
        <Grid container className={classes.footerContentGrid}>
          <Grid item xs={6} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <Typography style={{ fontSize: '0.9rem' }}>Copyright {new Date().getFullYear()} ČEZ, a.s.</Typography>
            <Typography style={{ fontSize: '0.9rem' }}>|</Typography>
            <Typography style={{ fontSize: '0.9rem' }}>
              <a href="https://www.cezesco.cz/cs/prohlaseni-o-pristupnosti" target="_blank" rel="noopener noreferrer">
                <FormattedMessage id={'app.footer.accessibility'} />
              </a>
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.scrollToTopGrid}>
            <Typography className={classes.scrollToTop} onClick={scrollToTop}>
              <ExpandLessIcon />
              <FormattedMessage id={'app.layout.up'} />
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Footer;
